import type { Route } from '@angular/router';
import { NotFoundComponent } from '@comparit/core';
import { ShellComponent } from './shell.component';
import { KfzRoutes } from './app.routes.paths';
import { setOrderResultsGuard } from './set-order-results/set-order-results.guard';
import { stayWhileSendingGuard } from './vergleich/antrag/antrag-sending.guard';

/** Strip the leading '/' so the string is usable as a route `path`. */
const seg = (absolutePath: string) => absolutePath.slice(1);

export const appRoutes: Route[] = [
  {
    // Standalone loading page: hydrates sessionStorage from a saved-task token,
    // then SPA-navigates into the shell. Deliberately OUTSIDE ShellComponent so
    // FormsService is not constructed before the storage is written.
    path: seg(KfzRoutes.laden),
    loadComponent: () => import('./laden/laden.component').then(c => c.LadenComponent),
  },
  {
    path: seg(KfzRoutes.logout),
    loadComponent: () => import('./logout/logout.component').then(c => c.LogoutComponent),
  },
  {
    path: '',
    component: ShellComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: seg(KfzRoutes.formular),
      },
      {
        path: seg(KfzRoutes.formular),
        loadChildren: () => import('./formular/formular.routes').then(r => r.formularRoutes),
      },
      {
        path: seg(KfzRoutes.rechner),
        loadComponent: () => import('./results/results.component').then(c => c.ResultsComponent),
      },
      {
        path: seg(KfzRoutes.vergleich),
        loadComponent: () =>
          import('./vergleich/vergleich.component').then(c => c.VergleichComponent),
      },
      {
        path: seg(KfzRoutes.angebot),
        loadComponent: () => import('./angebot/angebot.component').then(c => c.AngebotComponent),
      },
      {
        path: seg(KfzRoutes.tarifdetailsLaden),
        loadComponent: () =>
          import('./tarifdetails/tarifdetails-laden/tarifdetails-laden.component').then(
            c => c.TarifdetailsLadenComponent
          ),
      },
      {
        path: seg(KfzRoutes.tarifdetails),
        loadComponent: () =>
          import('./tarifdetails/tarifdetails.component').then(c => c.TarifdetailsComponent),
        canDeactivate: [stayWhileSendingGuard],
      },
      {
        path: seg(KfzRoutes.setOrderResults),
        canActivate: [setOrderResultsGuard],
        loadComponent: () =>
          import('./set-order-results/set-order-results.component').then(
            c => c.SetOrderResultsComponent
          ),
      },
    ],
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];
